/*** IMPORTS FROM imports-loader ***/
(function() {

define([
	'jquery',
	'pip-events',
	'plugin.tooltip',
	'window',
	'pip-model'
],
function(
	$,
	pipEvents,
	tooltip,
	window,
	pip
){
	var view = {
		selectors: {
			prop65Link: '.prop65-warning__link',
			prop65Details: '.prop65-tooltip__details'
		},

		templates: {
			prop65Tooltip: $('.prop65-tooltip-template').html()
		},

		attachTooltips: function () {
			$(view.selectors.prop65Link).tooltip({
				type: 'click',
				position: 'bottom',
				bestPosition: false,
				closeButton: true,
				closeOnClick: true,
				content: function () {
					return view.templates.prop65Tooltip
				},
				onOpen: function (content, open) {
					var details = $(content).find(view.selectors.prop65Details).text().trim();
					details.length ? open() : window.open('/c/FAQ#65', '_blank');
				}
			});
		}
	}

	function initAppEventListeners () {
		pipEvents.cards.cardOverlayDisplayed.on(function() {
			view.attachTooltips();
		});
	}

	return {
		init: function init() {
      view.attachTooltips();
      initAppEventListeners();
		},
		view: view
	};

});

}.call(window));